import React from 'react'
import { Card, Text, Row, Text2 } from './common'
import { Button, Stack } from '@mui/material'

interface ExitSpaceProps {
  onExit: () => void
}

const ExitSpace: React.FC<ExitSpaceProps> = ({ onExit }) => {
  return (
    <Card>
      <Row sx={{ py: 0, alignItems: 'flex-start' }}>
        <Text sx={{ width: 400 }}>
          退出空间
          <Text2 sx={{ color: 'rgba(0,0,0,0.5)' }}>将不可见您在该空间所产生的所有数据，请谨慎操作</Text2>
        </Text>
        <Stack direction='row' sx={{ flex: 1 }} justifyContent='flex-end'>
          <Button size='small' color='error' onClick={onExit}>
            退出
          </Button>
        </Stack>
      </Row>
    </Card>
  )
}

export default ExitSpace
